import { Menu, MenuItem, Typography } from '@mui/material';
import { AlertCamera } from 'features/cameras/cameras.types';
import { PopupState, bindMenu } from 'material-ui-popup-state/hooks';
import { useTranslation } from 'react-i18next';
import { parseReplayTime } from './CameraPlayer.utils';
import { REPLAY_TIME_OPTIONS_SECONDS } from './CameraReplayTimeMenu.constants';

type CameraReplayTimeMenuProps = {
  camera: AlertCamera;
  isLoading: boolean;
  popupState: PopupState;
  setTimelapseReplayTime: (replayTime: number) => void;
};

const isReplayTimeEnabledForCamera = (
  camera: AlertCamera,
  replayTime: number,
): boolean => camera.hasPtz || replayTime / 60 >= 30;

export const CameraReplayTimeMenu = (
  props: CameraReplayTimeMenuProps,
): JSX.Element => {
  const { camera, isLoading, popupState, setTimelapseReplayTime } = props;
  const { t } = useTranslation();

  const handleSetReplayTime = (time: number): void => {
    setTimelapseReplayTime(time);
    popupState.close();
  };

  return (
    <Menu
      {...bindMenu(popupState)}
      disablePortal
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      transformOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    >
      {REPLAY_TIME_OPTIONS_SECONDS.map((time) => (
        <MenuItem
          key={time}
          sx={{ padding: '4px 16px' }}
          onClick={() => handleSetReplayTime(time)}
          disabled={isLoading || !isReplayTimeEnabledForCamera(camera, time)}
        >
          <Typography key={time} variant="subtitle1" component="p">
            {parseReplayTime(time, t)}
          </Typography>
        </MenuItem>
      ))}
    </Menu>
  );
};
